import {
  Autocomplete,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { PersonalDetailsForm } from "../../model/personal_details/personal_details";
import { EducationalDetailsForm } from "../../model/educational_Details/educational_details";

interface Props {}

function EducationDetails(props: EducationalDetailsForm) {
  const {
    highestQualification,
    setHighestQualification,
    fieldOfStudy,
    setFieldOfStudy,
    currentOccupation,
    setCurrentOccupation,
    jobTitle,
    setJobTitle,
    industry,
    setIndustry,
    companyName,
    setCompanyName,
    setSurveyStep,
    surveyStep,
    setCustomFieldOfStudy,
    customIndustry,
    setCustomIndustry,
    customOccupation,
    setCustomOccupation,
    customFieldOfStudy,
  } = props;

  const qualification = [
    { id: 1, value: "SSLC" },
    { id: 2, value: "PUC" },
    { id: 3, value: "ITI" },
    { id: 4, value: "Diploma" },
    { id: 5, value: "Undergraduate" },
    { id: 6, value: "Graduate" },
    { id: 7, value: "Postgraduate" },
    { id: 8, value: "MPhil" },
    { id: 9, value: "PhD" },
    { id: 10, value: "Postdoc" },
  ];

  const fieldOfStudyList = [
    { id: 1, value: "Science" },
    { id: 2, value: "Commerce" },
    { id: 3, value: "Arts" },
    { id: 4, value: "Engineering" },
    { id: 5, value: "Computer Applications" },
    { id: 6, value: "Education" },
    { id: 7, value: "Law" },
    { id: 8, value: "Medical" },
    { id: 9, value: "Nursing" },
    { id: 10, value: "Pharmacy" },
    { id: 11, value: "Management" },
    { id: 12, value: "Social Work" },
    { id: 13, value: "Agriculture" },
    { id: 14, value: "Design" },
    { id: 15, value: "Architecture" },
    { id: 16, value: "Hotel Management" },
    { id: 17, value: "Fine Arts" },
    { id: 18, value: "Theology" },
    { id: 19, value: "Journalism & Mass Communication" },
    { id: 20, value: "Others" },
  ];

  const currentOccupationList = [
    { id: 1, value: "Student" },
    { id: 2, value: "Employed (Full-time)" },
    { id: 3, value: "Employed (Part-time)" },
    { id: 4, value: "Entrepreneur" },
    { id: 5, value: "Freelancer" },
    { id: 6, value: "Self-employed" },
    { id: 7, value: "Unemployed" },
    { id: 8, value: "Home Maker" },
    { id: 9, value: "Intern" },
    { id: 10, value: "Retired" },
    { id: 11, value: "Volunteer" },
    { id: 12, value: "Others" },
  ];

  const industryList = [
    { id: 1, value: "Information Technology (IT)" },
    { id: 2, value: "Education" },
    { id: 3, value: "Healthcare" },
    { id: 4, value: "Engineering" },
    { id: 5, value: "Finance & Banking" },
    { id: 6, value: "Marketing & Advertising" },
    { id: 7, value: "Media & Entertainment" },
    { id: 8, value: "Agriculture" },
    { id: 9, value: "Construction" },
    { id: 10, value: "Retail" },
    { id: 11, value: "Transportation & Logistics" },
    { id: 12, value: "Manufacturing" },
    { id: 13, value: "Telecommunications" },
    { id: 14, value: "Legal Services" },
    { id: 15, value: "Government Services" },
    { id: 16, value: "Hospitality & Tourism" },
    { id: 17, value: "Real Estate" },
    { id: 18, value: "Non-Profit / NGO" },
    { id: 19, value: "Arts & Culture" },
    { id: 20, value: "Others" },
  ];

  return (
    <Box mt={1}>
      <Box>
        <Typography fontWeight={600} variant="h5">
          Educational and Work Details
        </Typography>
      </Box>
      <Grid container mt={1} spacing={4}>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            15. Highest Qualification<span style={{ color: "red" }}>*</span>
          </Typography>
          <Autocomplete
            sx={{ mt: 2 }}
            fullWidth
            value={
              qualification.find(
                (option) => highestQualification?.id === option.id
              ) || null
            }
            onChange={(e, value) => {
              setHighestQualification(value);
            }}
            options={qualification}
            getOptionLabel={(option) => option.value || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Highest Qualification"
              />
            )}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            16. Field of study<span style={{ color: "red" }}>*</span>
          </Typography>
          <Autocomplete
            sx={{ mt: 2 }}
            fullWidth
            value={
              fieldOfStudyList.find(
                (option) => fieldOfStudy?.id === option.id
              ) || null
            }
            onChange={(e, value) => {
              setFieldOfStudy(value);
            }}
            options={fieldOfStudyList}
            getOptionLabel={(option) => option.value || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Field of study"
              />
            )}
          />
          {fieldOfStudy?.value === "Others" && (
            <TextField
              fullWidth
              sx={{ mt: 2 }}
              label="Enter your field of study"
              value={customFieldOfStudy}
              onChange={(e) => setCustomFieldOfStudy(e.target.value)}
            />
          )}
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            17. Current Occupation<span style={{ color: "red" }}>*</span>
          </Typography>
          <Autocomplete
            sx={{ mt: 2 }}
            fullWidth
            value={
              currentOccupationList.find(
                (option) => currentOccupation?.id === option.id
              ) || null
            }
            onChange={(e, value) => {
              setCurrentOccupation(value);
            }}
            options={currentOccupationList}
            getOptionLabel={(option) => option.value || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Current Occupation"
              />
            )}
          />
          {currentOccupation?.value === "Others" && (
            <TextField
              fullWidth
              sx={{ mt: 2 }}
              label="Enter your Occupation"
              value={customOccupation}
              onChange={(e) => setCustomOccupation(e.target.value)}
            />
          )}
        </Grid>

        {currentOccupation?.id != 1 &&
          currentOccupation?.id != 7 &&
          currentOccupation?.id !== 8 &&
          currentOccupation?.id !== 12 && (
            <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle1" fontWeight={500}>
                18. Job Title<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                sx={{ mt: 2 }}
                fullWidth
                onChange={(e) => setJobTitle(e.target.value)}
                value={jobTitle}
              />
            </Grid>
          )}

        {currentOccupation?.id != 1 &&
          currentOccupation?.id != 7 &&
          currentOccupation?.id !== 8 &&
          currentOccupation?.id !== 12 && (
            <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle1" fontWeight={500}>
                19. Industry<span style={{ color: "red" }}>*</span>
              </Typography>
              <Autocomplete
                sx={{ mt: 2 }}
                fullWidth
                value={
                  industryList.find((option) => industry?.id === option.id) ||
                  null
                }
                onChange={(e, value) => {
                  setIndustry(value);
                }}
                options={industryList}
                getOptionLabel={(option) => option.value || ""}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Industry" />
                )}
              />
              {industry?.value === "Others" && (
                <TextField
                  fullWidth
                  sx={{ mt: 2 }}
                  label="Enter your Industry"
                  value={customIndustry}
                  onChange={(e) => setCustomIndustry(e.target.value)}
                />
              )}
            </Grid>
          )}
        {currentOccupation?.id != 1 &&
          currentOccupation?.id != 7 &&
          currentOccupation?.id !== 8 &&
          currentOccupation?.id !== 12 && (
            <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
              <Typography variant="subtitle1" fontWeight={500}>
                20. Company Name<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                sx={{ mt: 2 }}
                fullWidth
                onChange={(e) => setCompanyName(e.target.value)}
                value={companyName}
              />
            </Grid>
          )}
        {currentOccupation?.id == 1 ||
          currentOccupation?.id == 7 ||
          currentOccupation?.id == 8 ||
          currentOccupation?.id == 12 || (
            <Grid item sm={12} xs={12} md={6} lg={6} xl={6}></Grid>
          )}
        <Grid item sm={6} xs={6} md={3} lg={3} xl={3}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={() => setSurveyStep(surveyStep - 1)}
          >
            Previous
          </Button>
        </Grid>
        <Grid item sm={6} xs={6} md={3} lg={3} xl={3}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={() => setSurveyStep(surveyStep + 1)}
            disabled={
              !highestQualification ||
              !fieldOfStudy ||
              !currentOccupation ||
              !jobTitle ||
              !industry ||
              !companyName
            }
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default EducationDetails;
